import {
    SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD,
    SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_SUCCESS,
    SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_ERROR,
    SEARCH_ROOMS,
    SEARCH_ROOMS_SUCCESS,
    SEARCH_ROOMS_ERROR,
    ASSIGN_ROOM,
    ASSIGN_ROOM_SUCCESS,
    ASSIGN_ROOM_ERROR,
    SEARCH_ROOMS_RESET_FORM,
    NAVIGATE_TO_STEP,
    CLEAR_ROOM_ASSIGNMENT_RESPONSE,
    SET_ROOMS_SELECTED,
    DEALLOCATE_ROOM_ERROR,
    DEALLOCATE_ROOM,
    DEALLOCATE_ROOM_SUCCESS,
    CLEAN_DEALLOCATE_STUDENTS,
    RESET_DEALLOCATE_ROOM_FINISH,
    CLEAR_ROOM_SEARCH_RESULTS
} from "./housingRoomSearchActionTypes";
import {
    getApi,
    postApi
} from "../../../services/apiBase";
import { studentLifeAPIs } from "../../../services/apiURL";


export const getPropertiesForHousingPeriod = (housingPeriodID) => async (dispatch) => {

    dispatch({ type: SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD });

    try {
        const response = await getApi(`${studentLifeAPIs.housingPeriods.roomAssignments.getPropertiesForHousingPeriod}?housingPeriodID=${housingPeriodID}`);
        const results = response.data.data;
        
        dispatch({ type: SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_SUCCESS, payload: results });
    }
    catch (err) {
        dispatch({ type: SEARCH_ROOMS_GET_PROPERTIES_FOR_HOUSING_PERIOD_ERROR });
        console.error(err);
    }
}

export const searchRooms = (searchCriteria) => async (dispatch) => {
    dispatch({ type: SEARCH_ROOMS });

    try {
        const response = await postApi(`${studentLifeAPIs.housingPeriods.roomAssignments.roomSearch}`, searchCriteria);
        const results = response.data.data;
        const flattenedResults = results.map(result => ({
            ...result,
            housingPeriodRoomID: result.room.housingPeriodRoomID,
            housingPeriodFloorID: result.room.housingPeriodFloorID,
            unit: result.room.unit,
            roomName: result.room.roomName,
            isActive: result.room.isActive,
            emotionalSupportAnimal: result.room.emotionalSupportAnimal,
            occupancy: result.room.occupancy
        }));
        dispatch({ type: SEARCH_ROOMS_SUCCESS, payload: flattenedResults });
    }
    catch (err) {
        dispatch({ type: SEARCH_ROOMS_ERROR });
        console.error(err);
    }
}

export const assignRoom = (payload) => async (dispatch) => {
    dispatch({ type: ASSIGN_ROOM });

    try {
        const response = await postApi(`${studentLifeAPIs.housingPeriods.roomAssignments.assignRoom}`, payload);
        const results = response.data;
        dispatch({ type: ASSIGN_ROOM_SUCCESS, payload: results });
    }
    catch (err) {
        dispatch({ type: ASSIGN_ROOM_ERROR });
        console.error(err);

    }
}

export const resetSearch = () => async (dispatch) => {
    dispatch({ type: SEARCH_ROOMS_RESET_FORM });
}

export const navigateToNextStep = (step) => async (dispatch) => {
    dispatch({ type: NAVIGATE_TO_STEP, payload: step })
}

export const navigateToStep = (step) => async (dispatch) => {
    dispatch({ type: NAVIGATE_TO_STEP, payload: step })
}

export const clearRoomAssignmentResponse = () => async (dispatch) => {
    dispatch({ type: CLEAR_ROOM_ASSIGNMENT_RESPONSE });
}


export const setRoomSelected = (roomSelected) => async (dispatch) => {
    dispatch({ type: SET_ROOMS_SELECTED, payload: roomSelected});
}

export const deallocateRoom = (payload) => async (dispatch) => {
    dispatch({ type: DEALLOCATE_ROOM });

    try {
        const response = await postApi(`${studentLifeAPIs.housingPeriods.roomAssignments.deallocateRoom}`, payload);
        const results = response.data;
        dispatch({ type: DEALLOCATE_ROOM_SUCCESS, payload: results });
    }
    catch (err) {
        dispatch({ type: DEALLOCATE_ROOM_ERROR });
        console.error(err);
    }
}

export const cleanStudentsFromDeallocateRoom = () => async (dispatch) => {
    dispatch({ type: CLEAN_DEALLOCATE_STUDENTS });
}

export const resetDeallocateRoomFinish = () => async (dispatch) => {
    dispatch({ type: RESET_DEALLOCATE_ROOM_FINISH });
}

export const clearRoomSearchResults = () => async (dispatch) => {
    dispatch({ type: CLEAR_ROOM_SEARCH_RESULTS });
}